<template>
    <div class="pages">
        <div class="modal" v-if="show">
            <div class="modal-box">
                <div class="modal-box-tit">{{ $t('提示') }}</div>
                <div class="modal-box-txt">{{ content }}</div>
                <div class="modal-box-btn">
                    <div class="btn-l" @click="onCancel">{{ $t('取消') }}</div>
                    <div class="btn-r" @click="onConfirm">{{ $t('确定') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'u-popup',
        props: {
            /**
             * 显示状态
             */
            show: {
                type: Boolean,
                default: false
            },
            content: {
                type: String,
                default: ''
            }
        },
        data() {
            return {

            }
        },
        methods: {
            /**取消 */
            onCancel() {
                this.$emit('close');
            },
            /**确定 */
            onConfirm() {
                this.$emit('confirm');
            }
        },
    };
</script>

<style scoped lang="scss">
    /**模态框 */
    .modal {
        width: 100vw;
        height: 100vh;
        /* background-color: rgba($color: #000000, $alpha: 0.5); */
        background-color: rgba(0, 0, 0, .5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;

        .modal-box {
            padding: 40px 45px;
            background-color: #FFFFFF;
            border-radius: 16px;
            text-align: center;

            .modal-box-tit {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }

            .modal-box-txt {
                font-size: 16px;
                margin: 24px 0 40px;
            }

            .modal-box-btn {
                display: flex;

                div {
                    width: 180px;
                    height: 40px;
                    border-radius: 4px;
                    line-height: 40px;
                    cursor: pointer;
                }

                .btn-l {
                    border: 1px solid #999999;
                    background: #FFFFFF;
                    color: #333333;
                }

                .btn-r {
                    background: #000;
                    color: #FFFFFF;
                    margin-left: 40px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/popup.vue